import React from "react";
import { Box, Typography, TextField, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";

const Section = ({ component, isEditing, onSave, mode }) => {
  // Aplicar estilos
  const getStyle = () => {
    const style = component.style || {};
    return {
      backgroundColor: style.backgroundColor || "transparent",
      borderRadius: style.borderRadius ? `${style.borderRadius}px` : "4px",
      border:
        mode === "response"
          ? "none"
          : style.borderWidth
            ? `${style.borderWidth}px solid ${style.borderColor || "#ccc"}`
            : "1px solid #ccc",
      padding: style.padding
        ? `${style.padding.top || 0}px ${style.padding.right || 0}px ${style.padding.bottom || 0}px ${style.padding.left || 0}px`
        : "8px",
      margin: style.margin
        ? `${style.margin.top || 0}px ${style.margin.right || 0}px ${style.margin.bottom || 0}px ${style.margin.left || 0}px`
        : "0",
      boxShadow: style.shadow?.enabled
        ? `${style.shadow.offsetX || 0}px ${style.shadow.offsetY || 0}px ${style.shadow.blur || 4}px ${style.shadow.color || "rgba(0,0,0,0.2)"}`
        : "none",
    };
  };

  const getTextStyle = () => {
    const textStyle = component.style?.textStyle || {};
    return {
      fontSize: textStyle.fontSize ? `${textStyle.fontSize}px` : "14px",
      fontWeight: textStyle.fontWeight || "normal",
      color: textStyle.color || "#000000",
      textAlign: textStyle.textAlign || "left",
      fontFamily: textStyle.fontFamily || "inherit",
    };
  };

  const getTitleStyle = () => {
    const textStyle = component.style?.textStyle || {};
    return {
      fontSize: textStyle.fontSize ? `${textStyle.fontSize * 1.2}px` : "18px",
      fontWeight: textStyle.fontWeight || "semibold",
      color: textStyle.color || "#000000",
      textAlign: textStyle.textAlign || "left",
      fontFamily: textStyle.fontFamily || "inherit",
    };
  };

  if (component.collapsible) {
    return (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          ...getStyle(),
        }}
      >
        {isEditing ? (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <TextField
              defaultValue={component.title}
              variant="outlined"
              size="small"
              onBlur={(e) => onSave({ title: e.target.value })}
              onKeyPress={(e) => e.key === "Enter" && e.target.blur()}
              autoFocus
            />
            <TextField
              defaultValue={component.description}
              variant="outlined"
              size="small"
              onBlur={(e) => onSave({ description: e.target.value })}
              onKeyPress={(e) => e.key === "Enter" && e.target.blur()}
            />
            <TextField
              type="checkbox"
              label="Colapsible"
              checked={component.collapsible}
              onChange={(e) => onSave({ collapsible: e.target.checked })}
            />
          </Box>
        ) : (
          <Accordion defaultExpanded={component.expanded !== false}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "semibold",
                  color: "text.primary",
                  ...getTitleStyle(),
                }}
              >
                {component.title}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              {component.description && (
                <Typography
                  variant="body2"
                  sx={{
                    color: "text.secondary",
                    mt: 0.5,
                    ...getTextStyle(),
                  }}
                >
                  {component.description}
                </Typography>
              )}
            </AccordionDetails>
          </Accordion>
        )}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        ...getStyle(),
      }}
    >
      {isEditing ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <TextField
            defaultValue={component.title}
            variant="outlined"
            size="small"
            onBlur={(e) => onSave({ title: e.target.value })}
            onKeyPress={(e) => e.key === "Enter" && e.target.blur()}
            autoFocus
          />
          <TextField
            defaultValue={component.description}
            variant="outlined"
            size="small"
            onBlur={(e) => onSave({ description: e.target.value })}
            onKeyPress={(e) => e.key === "Enter" && e.target.blur()}
          />
        </Box>
      ) : (
        <Box>
          <Typography
            variant="h6"
            sx={{
              fontWeight: "semibold",
              color: "text.primary",
              ...getTitleStyle(),
            }}
          >
            {component.title}
          </Typography>
          {component.description && (
            <Typography
              variant="body2"
              sx={{
                color: "text.secondary",
                mt: 0.5,
                ...getTextStyle(),
              }}
            >
              {component.description}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

export default Section;
